import { render } from "./2017-03-29-Python NLTK.md?vue&type=template&id=67b938b4"
const script = {}
script.render = render

export default script